import React from "react";
import { ReportAuthor } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import { renderRichText } from "@/lib/richText";

interface ReportAuthorProps {
  blok?: ReportAuthor & SbBlokData;
}

const ReportAuthorComponent: React.FC<ReportAuthorProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, position, company, quote, image } = blok;

  return (
    <>
      <div {...storyblokEditable(blok)} className="container py-4 py-md-5">
        <div className="row justify-content-center">
          <div className="col-lg-20 col-xl-18 col-xxl-16">
            <div className="d-md-flex">
              {image?.filename && (
                <>
                  <Image
                    src={image.filename}
                    alt={image.alt || `${title} Avatar`}
                    title={`${title} Avatar`}
                    className="d-md-none mb-3 me-md-4 mb-md-0"
                    width={100}
                    height={100}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    loading="lazy"
                    quality={75}
                  />
                  <Image
                    src={image.filename}
                    alt={image.alt || `${title} Avatar`}
                    title={`${title} Avatar`}
                    className="d-none d-md-block mb-3 me-md-4 mb-md-0"
                    width={200}
                    height={200}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    loading="lazy"
                    quality={75}
                  />
                </>
              )}
              <div>
                {title && <h3 className="mb-0">{title}</h3>}
                {(position || company) && (
                  <p className="small">
                    {position}
                    {position && company && ", "}
                    {company && company}
                  </p>
                )}
                {quote && (
                  <div className="mb-0" dangerouslySetInnerHTML={{ __html: renderRichText(quote) }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
};

export default ReportAuthorComponent;